import { render, staticRenderFns } from "./Anime.vue?vue&type=template&id=362e3b99&scoped=true&"
import script from "./Anime.vue?vue&type=script&lang=js&"
export * from "./Anime.vue?vue&type=script&lang=js&"
import style0 from "./Anime.vue?vue&type=style&index=0&id=362e3b99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362e3b99",
  null
  
)

export default component.exports